export const customerReferralSelector = (state) => ({
  customerReferral: state.referral.customerReferral
});

export const referralRegistrationSelector = (state) => ({
  referralRegistration: state.referral.registration
});
